module.exports = __webpack_public_path__ + "6d6b6ceffeeb07458c6468db47b6c1fd.png";